import AppLinks from './AppLinks'

export default AppLinks
// eslint-disable-next-line import/export
export * from './AppLinks'
